export default __webpack_public_path__ + "static/media/animal-6.85ab4489.svg";